
const piURL_API = "http://192.168.0.75/api"
const piURL = "http://192.168.0.75"
const kongrooURL_API = "https://rm.kongroo.xyz/api"
const kongrooURL = "https://rm.kongroo.xyz"
const backendURL = "http://localhost:3001"

export const SERVER_URL = process.env.REACT_APP_API_ROUTE;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_ROUTE;